import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'

interface EditPrescriptionStepProps {
  onProceed?: () => void
}

export function EditPrescriptionStep({ onProceed }: EditPrescriptionStepProps) {
  const { t } = useTranslation('Dialogs')

  return (
    <div>
      <p>{t('SWAP_PRODUCT_DIALOG.RX_PLACEHOLDER')}</p>
      {onProceed && (
        <KibButtonNew onClick={onProceed}>{t('Common:PROCEED')}</KibButtonNew>
      )}
    </div>
  )
}
